// Configuration de l'API
const getApiUrl = (): string => {
  // En production, utiliser l'URL absolue du backend
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://api.tiikod.fr/admin';
  }

  // En développement, utiliser localhost
  return process.env.REACT_APP_API_URL || 'http://localhost:5001';
};

export const API_BASE_URL = getApiUrl();

// Helper pour construire les URLs d'API
export const buildApiUrl = (endpoint: string): string => {
  // En production, on préfixe avec /admin
  if (process.env.NODE_ENV === 'production') {
    // Si l'endpoint commence par /api, on ajoute /admin devant
    if (endpoint.startsWith('/api')) {
      return `${API_BASE_URL}${endpoint}`;
    }
    // Sinon on ajoute /admin devant l'endpoint
    return `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
  }

  // En développement, on ajoute l'endpoint à l'URL de base
  return `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
}; 